import { VITALS } from "./vitalCategories";
import styles from "./styles.module.css";

/**
 * Dynamic vital category summary legend (SCRUM-137). Renders ONE card per
 * vital that is actually present in the rows currently shown in the table
 * (no hardcoded fixed set), each listing its color-coded categories with the
 * standard clinical ranges from the design.
 */
const VitalLegend = ({ vitalKeys }) => {
  const visible = VITALS.filter((v) => vitalKeys.includes(v.key));
  if (!visible.length) return null;

  return (
    <div className={styles.legend}>
      {visible.map((vital) => (
        <div key={vital.key} className={styles.legendCard}>
          <div className={styles.legendTitle}>{vital.label}</div>
          <div className={styles.legendCats}>
            {vital.categories.map((cat) => (
              <div key={cat.key} className={styles.legendCat}>
                <span
                  className={styles.catDot}
                  style={{ backgroundColor: cat.color }}
                />
                <div>
                  <div className={styles.legendCatLabel}>{cat.label}</div>
                  <div className={styles.legendCatRange}>{cat.range}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VitalLegend;
